import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  loadingText: (
    <FormattedMessage
      id="App.LoadingText"
      defaultMessage="Loading"
    ></FormattedMessage>
  ),
  templateTitle: (
    <FormattedMessage
      id="Websms.TemplateTitle"
      defaultMessage="Templates"
    ></FormattedMessage>
  ),
  templateAddTitle: (
    <FormattedMessage
      id="Websms.TemplateAddTitle"
      defaultMessage="New Template"
    ></FormattedMessage>
  ),
  templateEditTitle: (
    <FormattedMessage
      id="Websms.TemplateEditTitle"
      defaultMessage="Edit Template"
    ></FormattedMessage>
  ),
  nameText: (
    <FormattedMessage
      id="Websms.TemplateNameText"
      defaultMessage="Template Name"
    ></FormattedMessage>
  ),
  templateDetailsTitle: (
    <FormattedMessage
      id="Websms.TemplateDetailsTitle"
      defaultMessage="Template Details"
    ></FormattedMessage>
  ),
  contentText: (
    <FormattedMessage
      id="Websms.TemplateMessageText"
      defaultMessage="Template Message"
    ></FormattedMessage>
  ),
  contactType: (
    <FormattedMessage id="Websms.ContactType" defaultMessage="Contact Type" />
  ),
  backButton: (
    <FormattedMessage
      id="App.BackButton"
      defaultMessage="Back"
    ></FormattedMessage>
  ),
  cancelText: (
    <FormattedMessage
      id="Websms.CancelText"
      defaultMessage="Cancel"
    ></FormattedMessage>
  ),
  saveText: (
    <FormattedMessage id="Websms.Save" defaultMessage="Save"></FormattedMessage>
  ),
  saving: (
    <FormattedMessage
      id="Websms.Saving"
      defaultMessage="Saving..."
    ></FormattedMessage>
  ),
  deleteText: (
    <FormattedMessage
      id="Websms.DeleteText"
      defaultMessage="Delete"
    ></FormattedMessage>
  ),
  templateName: (
    <FormattedMessage
      id="Websms.TemplateName"
      defaultMessage="Template Name"
    ></FormattedMessage>
  ),
  templateType: (
    <FormattedMessage
      id="Websms.TemplateType"
      defaultMessage="Type"
    ></FormattedMessage>
  ),
  deleteSelected: (
    <FormattedMessage
      id="Websms.DeleteSelected"
      defaultMessage="Delete Selected"
    ></FormattedMessage>
  ),
  createNewButton: (
    <FormattedMessage
      id="Websms.CreateNewButton"
      defaultMessage="Create New"
    ></FormattedMessage>
  ),
  personalTemplateTitle: (
    <FormattedMessage
      id="Websms.PersonalTemplateTitle"
      defaultMessage="Personal Templates"
    ></FormattedMessage>
  ),
  searchPersonalTemplates: (
    <FormattedMessage
      id="Websms.searchPersonalTemplates"
      defaultMessage="Search Personal Templates"
    ></FormattedMessage>
  ),
  globalTemplateTitle: (
    <FormattedMessage
      id="Websms.GlobalTemplateTitle"
      defaultMessage="Global Templates"
    ></FormattedMessage>
  ),
  searchGlobalTemplates: (
    <FormattedMessage
      id="Websms.searchGlobalTemplates"
      defaultMessage="Search Global Templates"
    ></FormattedMessage>
  ),
  viewGuide: (
      <FormattedMessage
        id="Websms.viewGuide"
        defaultMessage="View File Format and Template Building Guide"></FormattedMessage>
    ),
};

export default FormattedMessages;
